import { AnyAction } from "redux";
import { actionTypeKeys } from "../actions/actionTypeKeys";
import { initialState } from "../store/initialState";
import { BranchHours } from "../../common/types/branch";

export default function branchHoursReducer(
  state: BranchHours[] = initialState.branchHours,
  action: AnyAction
): BranchHours[] {
  switch (action.type) {
    case actionTypeKeys.LOAD_ALL_BRANCH_HOURS_SUCCESS:
      return [...action.hours];
    default:
      return state;
  }
}
